import Service from "../../services";

const state = {};

const getters = {};

const actions = {
  save({ commit }, data) {
    return Service.tolls_scale.save(data).then((res) => {
      return res;
    });
  },
  update({ commit }, data) {
    return Service.tolls_scale.update(data).then((res) => {
      return res;
    });
  },
  delete({ commit }, id) {
    return Service.tolls_scale.delete(id).then((res) => {
      return res;
    });
  },

  getData({ commit }, page) {
    return Service.tolls_scale.getData(page).then((res) => {
      return res;
    });
  },
  getDataById({ commit }, id) {
    return Service.tolls_scale.getDataById(id).then((res) => {
      return res;
    });
  },
};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
